import Vue from 'vue';
import Router from 'vue-router';
import FloorplansPage from '@/pages/FloorplansPage/FloorplansPage';
import FloorplanList from '@/pages/FloorplansPage/FloorplanList/FloorplanList';
import FloorplanDetail from '@/pages/FloorplansPage/FloorplanDetail/FloorplanDetail';
import AmenitiesPage from '@/pages/AmenitiesPage/AmenitiesPage';
import GalleryPage from '@/pages/GalleryPage/GalleryPage';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: (window.location.href.indexOf('keeley-demo') > -1) ? '/keeley-demo/' : '/',
  routes: [
    {
      path: '/',
      component: FloorplansPage,
      children: [
        {
          name: 'FloorplanList',
          path: '/',
          component: FloorplanList
        },
        {
          name: 'FloorplanDetail',
          path: 'floorplan/:id',
          component: FloorplanDetail
        }
      ]
    },
    {
      name: 'AmenitiesPage',
      path: '/Amenities',
      component: AmenitiesPage,
    },
    {
      name: 'GalleryPage',
      path: '/Gallery',
      component: GalleryPage
    }
  ],
  scrollBehavior(to, from) {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (to.name === 'FloorplanDetail' && from.name === 'FloorplanList') {
          resolve({ x: 0, y: 0 });
        }
        resolve();
      }, 300);
    });
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js